export const defaultLatitude = 39.88021;
export const defaultLongitude = -74.870281;
export const defaultDisplayAddress = "Marlton, NJ";
export const defaultTimeZone = "America/New_York";
